import React from 'react';
import './WhatsAppButton.css';

function WhatsAppButton() {
  const handleClick = () => {
    const message = encodeURIComponent(
      'Hola 👋, ¿qué tal? Vi su software para empresas de servicio técnico y me gustaría saber más información.'
    );
    const phoneNumber = '51964206288'; // Número de WhatsApp
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');
  };

  return (
    <button className="whatsapp-button" onClick={handleClick}>
      <span className="whatsapp-icon">💬</span>
      <span className="whatsapp-tooltip">¿Necesitas ayuda?</span>
    </button>
  );
}

export default WhatsAppButton;
